export default __webpack_public_path__ + "static/centralized-brand-assets@2x-cd62cac3b9f2cf1905167788674bbced.png";